<template>
  <modal
    id="unpublish-modal"
    :is-opened="isOpened"
    :on-close="close"
  >
    <template #header>
      {{ modalTitle }}
    </template>
    <template #body>
      <div class="modal-state">
        <div v-show="!detail">
          <!-- eslint-disable vue/no-v-html -->
          <p v-html="translatedMessage" />
          <!-- eslint-enable vue/no-v-html -->
          <div class="modal-state__actions">
            <button
              class="btn btn--secondary"
              @click="close()"
            >
              {{ trans('global.cancel') }}
            </button>
            <button
              class="btn btn--primary modal-default-button confirm-button"
              @click="displayDetail()"
            >
              {{ trans('offer.state.modal.moderation.unpublish.buttons.unpublish') }}
            </button>
          </div>
        </div>
        <!-- eslint-disable vue/no-v-html -->
        <div v-show="detail" v-html="htmlBody" />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </template>
  </modal>
</template>

<script>
import { isLength, isEmpty } from 'validator';
import Modal from '@components/Modal.vue';
import { URL_OFFER_ACTION_UNPUBLISH, URL_OFFER_VIEW } from '@tools/routes/routes';
import Attach from '@tools/attach';
import Logger from '@tools/logger/logger';
import requests from '@tools/requests-mixin';
import TwigFormValidator from '@tools/twig-form/validator';
import { hideSubmitLoader } from '@atoms/spinner';
import translation from '@elements/translation';

/**
 * Unpublish Modal Component
 *
 * This component use the modal component as a child.
 * It displays the unpublish offer form.
 */
export default {
  components: { Modal },
  mixins: [ translation, requests ],
  props: {
    isOpened: { type: Boolean, default: false },
    offerHashId: { type: String, default: '' },
    offerState: { type: String, default: '' },
    redirectUrl: { type: String, default: '' },
  },
  data() {
    return {
      htmlBody: '',
      modalTitle: '',
      detail: false,
      form: null,
      reason: null,
      dataTrad: {},
      translatedMessage: '',
    };
  },
  computed: {
    urlOfferUnpublish() {
      return URL_OFFER_ACTION_UNPUBLISH.replace('{id}', this.offerHashId);
    },
  },
  watch: {
    isOpened(newVal) {
      if (!newVal) {
        return;
      }

      this.modalTitle = this.trans('offer.state.modal.unpublish.title');
      this.translatedMessage = (this.offerState === 'moderation')
        ? this.trans('offer.state.modal.moderation.unpublish.text')
        : this.trans('offer.state.modal.unpublish.text');
    },
  },
  methods: {
    close() {
      this.detail = false;
      this.htmlBody = '';
      this.modalTitle = '';
      this.$emit('close');
    },
    initForm() {
      this.$nextTick(() => {
        const formSelector = 'form[name="transition_context"]';

        const reasonSelector = document.getElementById('transition_context_reason');
        const validator = new TwigFormValidator({
          formSelector,
          rules: {
            'transition_context[contact]': [ (value) => reasonSelector.value !== 'client_found_bap' || !isEmpty(value), (value) => isLength(value, { max: 80 }) ],
            'transition_context[service]': [ (value) => reasonSelector.value !== 'client_found_service' || !isEmpty(value), (value) => isLength(value, { max: 80 }) ],
            'transition_context[detail]': [ (value) => reasonSelector.value !== 'other' || !isEmpty(value), (value) => isLength(value, { max: 500 }) ],
          },
          messages: {
            'transition_context[contact]': [ 'required', 'tooLong' ],
            'transition_context[service]': [ 'required', 'tooLong' ],
            'transition_context[detail]': [ 'required', 'tooLong' ],
          },
          onSuccess: (event) => {
            Attach.asyncSubmit(event, this.urlOfferUnpublish)
              .then((result) => {
                const jsonResponse = JSON.parse(JSON.stringify(result.data));
                // Success
                if (jsonResponse.success) {
                  this.close();
                  this.reloadPage();
                }
              })
              .catch((result) => {
                this.htmlBody = result.data;
                this.initializeForm();
                hideSubmitLoader('#transition_context_save');
              })
              // init input placeholder animation after html added
              .then(this.$nextTick(() => {
                this.initForm();
              }));
          },
        });
        validator.init();

        document.querySelector(`${formSelector} .cancel`).addEventListener('click', (event) => {
          event.preventDefault();
          this.close();
        });
      });
    },
    displayDetail() {
      this.detail = true;

      this.get(this.urlOfferUnpublish).then((response) => {
        this.htmlBody = response.data;
        this.initializeForm();
      }).catch((error) => {
        Logger.debug(error);
      });
    },
    initializeForm() {
      this.initForm();
      this.$nextTick(() => {
        const reasonElement = document.querySelector('#transition_context_reason');
        this.reason = reasonElement.value;

        const that = this;
        reasonElement.addEventListener('change', function onReasonChange() {
          document.querySelectorAll('.transition-context__contact, .transition-context__service, .transition-context__detail')
            .forEach((element) => {
              element.classList.add('hidden');
            });
          that.reason = this.value;
          let selector;
          switch (that.reason) {
          case 'client_found_bap':
            selector = '.transition-context__contact';
            break;
          case 'client_found_service':
            selector = '.transition-context__service';
            break;
          case 'other':
            selector = '.transition-context__detail';
            break;
          default:
            break;
          }
          if (selector) {
            document.querySelector(selector).classList.remove('hidden');
          }
        });
        const reloadEl = document.querySelector('#reload-page');
        if (reloadEl) {
          reloadEl.addEventListener('click', this.reloadPage);
        }
      });
    },
    reloadPage() {
      const urlOfferView = URL_OFFER_VIEW.replace('{id}', this.offerHashId);
      const redirectUrl = this.redirectUrl || urlOfferView;
      window.location.href = redirectUrl;
    },
  },
};
</script>
